import { Action } from '@ngrx/store';
import { AuthActionType } from 'app/core/authentication/state/actions/auth-action-type.enum';

export class Logout implements Action {
  public readonly type: AuthActionType = AuthActionType.Logout;
  public readonly payload: undefined;
}

export class LogoutCompleted implements Action {
  public readonly type: AuthActionType = AuthActionType.LogoutCompleted;
  public readonly payload: undefined;
}

export class LogoutFailed implements Action {
  public readonly type: AuthActionType = AuthActionType.LogoutFailed;

  // TODO: Handle response code and message?
  constructor(public readonly payload: string) { }
}
